import React, { useContext, useState, useEffect,useCallback,useRef } from "react";
import { UserContext } from "../login/LoginForm";
import { AuthContext } from "../login/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Select, { components } from "react-select";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { colors } from "@mui/material";
import { toast } from "react-toastify";
import { debounce, set } from "lodash"; // Ensure lodash is installed
import { useSport } from '../../utils/SportsProvider';
import GlobalRadioButton from "../../components/UsefulComponent/GlobalRadioButton";
  

import  {searchSelectStyles,
  formSelectStyles,
  compactSelectStyles,
  errorSelectStyles} from "../../styles/components/selectStyles.js";
import MySvgButtonPlus from "../UsefulComponent/MySvgButtonPlus";
const TradingPreference = () => {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.TradingPreference[key][currentLang]; // Adjust the path according to your JSON structure

  const { userId, liveCsrfToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [templateTitle, setTemplateTitle] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [isOnlyAuto, setIsOnlyAuto] = useState(false);
  const [isOnlyRookie, setIsOnlyRookie] = useState(false);
  const [isOnlyNumber, setIsOnlyNumber] = useState(false);
  const [isOnlyRPA, setIsOnlyRPA] = useState(false);
  const [isOnlyTrueRookie, setIsOnlyTrueRookie] = useState(false);
  const [typeOfCard, setTypeOfCard] = useState("");
  const [otherDetails, setOtherDetails] = useState("");
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [selectedSets, setSelectedSets] = useState([]);
  const [playerOptions, setPlayerOptions] = useState([]);
  const [variation, setVariation] = useState([]);
  const [cardVariation, setCardVariation] = useState([]);
  const [setOptions, setSetOptions] = useState([]);
  const [filteredSets,setFilteredSets] = useState([])
  const [liveSelectedPlayers, setLiveSelectedPlayers] = useState([]);
  const [liveSelectedVariation, setLiveSelectedVariation] = useState([]);
  const [pokemonSpeciesOptions, setPokemonSpeciesOptions] = useState([]);
const [pokemonCardOptions, setPokemonCardOptions] = useState([]);
const [pokemonOptions, setPokemonOptions] = useState([]);
const [selectedPokemon, setSelectedPokemon] = useState([]);      // [[label, id], ...]
const [liveSelectedPokemon, setLiveSelectedPokemon] = useState([]); // [id, label]
const [pokemonSpecies, setPokemonSpecies] = useState(null);
const [pokemonAlreadyUsed, setPokemonAlreadyUsed] = useState(false);
// — Pokémon rarity prefs —
const [pokemonRarityOptions, setPokemonRarityOptions] = useState([]); // [{value:RarityId, label:Name}]
const [selectedPokemonRarityIds, setSelectedPokemonRarityIds] = useState([]); // [RarityId,...]
const [pokemonRarityExclusive, setPokemonRarityExclusive] = useState(false);  // Exclusively:
const [pokemonSearchAllSets, setPokemonSearchAllSets] = useState(true);
// --- Pokémon local state for this form ---
const [pokemonSet, setPokemonSet] = useState(null);
const [pokemonCard, setPokemonCard] = useState(null);
const [selectedPokemonCards, setSelectedPokemonCards] = useState([]); // [[label, id], ...]
const [pokemonCardAlreadyUsed, setPokemonCardAlreadyUsed] = useState(false);

const [holoOverride, setHoloOverride] = useState(""); // "", "Regular Holo", "Reverse Holo"
// ---- add near other state/refs ----
const baseCardsBySetRef = React.useRef({});   // { [setId]: Option[] } for per-set unfiltered lists
const baseAllCardsRef   = React.useRef([]);   // unfiltered list across ALL sets (optional)
const lastSetIdRef      = React.useRef(null);
// already have: pokemonCardOptions (state) and handlePokemonCardInput (debounced)
const speciesCacheRef = useRef(new Map());

  const { state } = useSport();
  const [activeType, setActiveType] = useState(state.sport);
// Mapper you already use/like
// const mapPokemonCards = (rows=[]) => rows.map(c => (
//   {
//   value: c.value,
//   label: c.SearchTitle,
//   RarityId: c.RarityId,
//   RarityName: c.RarityName,
//   ImageFront: c.ImageFront,
//   SetId: c.SetId,
//   NumberInSet: c.NumberInSet,
// }));



const mapPokemonCards = (rows = []) => {


  return rows.map((c) => {
   // console.log('[mapPokemonCards] row->opt:', c);
    return {
      value: c.value,          // or c.CardId if that’s what your API returns
      label: c.SearchTitle,    // or build `${c.CardName} #${c.NumberInSet} · ${c.RarityName}`
      RarityId: c.RarityId,
      RarityName: c.RarityName,
      ImageFront: c.ImageFront,
      SetId: c.SetId,
      NumberInSet: c.NumberInSet,
    };
  });
};

const [liveSelectedPokemonCard, setLiveSelectedPokemonCard] = useState(null);
  const [playerAlreadyUsed, setPlayerAlreadyUsed] = useState(false);
  const [liveSelectedSets, setLiveSelectedSets] = useState([]);
  const [setAlreadyUsed, setSetAlreadyUsed] = useState(false);
  const [variationAlreadyUsed, setVariationAlreadyUsed] = useState(false);
  const [selectedFromSets, setSelectedFromSets] = useState([]);
  const [selectedVariations, setSelectedVariations] = useState([]);
  const [selectedCardNames, setSelectedCardNames] = useState([]);
  const [liveSelectedCardName, setLiveSelectedCardName] = useState([]);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [selectedCardName, setSelectedCardName] = useState(null);
  const [filteredCardVariation, setFilteredCardVariation] = useState(null);
  const [tradingPreferences, setTradingPreferences] = useState([]);
  const [selectedTradingPreferenceId, setSelectedTradingPreferenceId] =
    useState(null);
  const [idCardVariationIdFromlistOfId, setIdCardVariationIdFromlistOfId] =
    useState([]);
  const [isNewTradingPreference, setIsNewTradingPreference] = useState(true);
const isPokemon = typeOfCard === "Pokemon";
  const [errors, setErrors] = useState({});

const AddMiniBtn = ({ onClick, disabled, label="Add" }) => (
  <button
    type="button"
    className="btn btn-primary"
    onClick={onClick}
    disabled={disabled}
    style={{ padding: "6px 10px", marginLeft: 8 }}
    aria-label={label}
    title={label}
  >
    <MySvgButtonPlus width={16} height={16} />
  </button>
);

const selectRowStyles = {
  ...formSelectStyles,
  // make the outer container flex-friendly
  container: (base) => ({ ...base, flex: 1, minWidth: 0 }),
  // keep your existing control overrides, just ensure width is auto
  control: (base, state) => ({
    ...formSelectStyles.control(base, state),
    width: '100%',          // this is within a flex item that can shrink
  }),
};

useEffect(() => {
  if (isPokemon) {
    fetchPokemonRarities();
  } else {
    fetchCardVariationOptions();
  }
  // reset ciblé pour éviter des incohérences d'objets entre sports
  setSelectedVariation(null);
  setSelectedCardName(null);
  setFilteredCardVariation(null);
  setVariation([]);
  console.log('isPokemon changed isPokemonisPokemonisPokemonisPokemon',isPokemon)
}, [isPokemon]);

    const selectStyles = {
    control: (base, state) => ({
      ...base,
      background: "rgba(255,255,255,.06)",
      borderColor: state.isFocused ? "#0071E7" : "rgba(255,255,255,.14)",
      boxShadow: "none",
      minHeight: 40,
      borderRadius: 12,
      color: "#fff",
      ":hover": { borderColor: state.isFocused ? "#0071E7" : "rgba(255,255,255,.22)" },
    }),
    valueContainer: (base) => ({ ...base, padding: "0 .75rem" }),
    singleValue: (base) => ({ ...base, color: "#fff" }),
    placeholder: (base) => ({ ...base, color: "rgba(255,255,255,.65)" }),
    input: (base) => ({ ...base, color: "#fff" }),
    dropdownIndicator: (base) => ({ ...base, color: "rgba(255,255,255,.7)" }),
    indicatorSeparator: (base) => ({ ...base, background: "rgba(255,255,255,.12)" }),
    menu: (base) => ({
      ...base,
      background: "#151a22",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 12,
      boxShadow: "0 12px 28px rgba(0,0,0,.45)",
      overflow: "hidden",
      zIndex: 50,
    }),
    menuList: (base) => ({ ...base, padding: 0, maxHeight: 280 }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected
        ? "#0a64e8"
        : state.isFocused
        ? "rgba(10,100,232,.15)"
        : "transparent",
      color: "#fff",
      cursor: "pointer",
      padding: "10px 12px",
      ":active": { background: "#0a64e8" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };


const fetchPokemonCards = async ({ setId, q = "", allSets = false }) => {
  // Build URL: when allSets = true, omit setId param
  const base = `${process.env.REACT_APP_API_BASE}/api/pokemon/cards`;
  const qs   = new URLSearchParams();
  if (!allSets && setId) qs.set("setId", setId);
  if (q) qs.set("q", q);
  const url  = `${base}?${qs.toString()}`;

  const { data } = await axios.get(url, { withCredentials: true });
  const opts = mapPokemonCards(data || []);

  console.log(`[fetchPokemonCards] fetched ${opts.length} cards for setId=${setId} allSets=${allSets} q="${q}"`, opts);
  setPokemonCardOptions(opts);

  // Cache only unfiltered base lists (q === "")
  if (!q) {
    if (allSets) {
      baseAllCardsRef.current = opts;
    } else if (setId) {
      baseCardsBySetRef.current[setId] = opts;
      lastSetIdRef.current = setId;
    }
  }
};
const fetchPokemonRarities = async (q = "") => {
  try {
    const url = `${process.env.REACT_APP_API_BASE}/api/pokemon/rarities${q ? `?q=${encodeURIComponent(q)}` : ""}`;
    const { data } = await axios.get(url, { withCredentials: true });
    // data peut déjà être {value,label}, sinon normalise:
    const opts = (data || []).map(r => ({
      value: r.value ?? r.RarityId,
      label: r.label ?? r.Name
    }));
    setPokemonRarityOptions(opts);
  } catch (e) {
    console.error("Error fetching pokemon rarities:", e);
  }
};

const fetchPokemonCardsForSet = async (setId, q = "") => {
  if (!setId) return setPokemonCardOptions([]);
  const url = `${process.env.REACT_APP_API_BASE}/api/pokemon/cards?setId=${encodeURIComponent(setId)}&q=${encodeURIComponent(q)}`;
  const { data } = await axios.get(url, { withCredentials: true });

  const opts = (data || []).map(item => ({
    value: item.value,
    label: item.SearchTitle,
    rarityId: item.RarityId,
    rarity: item.RarityName,
    image: item.ImageFront,
    setId: item.SetId,
    numberInSet: item.NumberInSet,

  }));

  // cache ONLY when q is empty (baseline list for that set)
  if (!q) baseCardsBySetRef.current[setId] = opts;

  setPokemonCardOptions(opts);
  return opts;
};


useEffect(() => {
  if (isPokemon) {
    fetchPokemonRarities();
    // reset la section variation hockey pour éviter les confusions
    setSelectedVariation(null);
    setSelectedCardName(null);
    setFilteredCardVariation(null);
    setVariation([]);
  }
}, [isPokemon]);

const speciesCache = useRef(new Map());

const fetchPokemonSpecies = async (q) => {
  const key = (q || "").toLowerCase().trim();
  if (speciesCacheRef.current.has(key)) {
    setPokemonSpeciesOptions(speciesCacheRef.current.get(key));
    return;
  }
  const url = `${process.env.REACT_APP_API_BASE}/api/pokemon/species?q=${encodeURIComponent(q)}`;
  const { data } = await axios.get(url, { withCredentials: true });
  const opts = (data || []).map(it => ({ value: it.PokemonId, label: it.CardName }));
  speciesCacheRef.current.set(key, opts);
  setPokemonSpeciesOptions(opts);
};

const handlePokemonSpeciesInput = useCallback(
  debounce((input) => {
    const q = (input || "").trim();
    if (q.length >= 2) fetchPokemonSpecies(q);
    else setPokemonSpeciesOptions([]);
  }, 250),
  []
);


const handleSavePokemon = (opt) => {
  setPokemonSpecies(opt || null);
  setLiveSelectedPokemon(opt ? [opt.value, opt.label] : null);
};

const handleAddPokemon = () => {
  const id = pokemonSpecies?.value;
  const label = pokemonSpecies?.label;
  if (!id || !label) {
    toast.error(t("Please select a valid Pokémon"));
    return;
  }
  const exists = selectedPokemon.some(p => p[1] === id);
  if (exists) { setPokemonAlreadyUsed(true); return; }
  setPokemonAlreadyUsed(false);
  setSelectedPokemon(prev => [...prev, [label, id]]);
  toast.success(t("Added"));
};

const handleRemovePokemon = (index) => {
  setSelectedPokemon(prev => {
    const next = [...prev];
    next.splice(index, 1);
    return next;
  });
};

const fetchTradingPreferencesOptions = useCallback(async (type) => {
  try {
    let url;
    switch (type) {
      case "Hockey":
        // Hockey-only (your existing all-purpose route is fine)
        url = `${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/${userId}`;
        break;
      case "Pokemon":
        // If you make a generic Pokemon route, use it here:
        // url = `${API}/api/get/trading-preferences/pokemon/${userId}`;
        // TEMP: fall back to PC if that's what you have today:
        url = `${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/pokemon/${userId}`;
        break;
      default: // "All"
        // If you adopt the unified endpoint I showed earlier, you could call it with ?type=All.
        url = `${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/${userId}`;
        break;
    }

    const { data } = await axios.get(url, { withCredentials: true });
    setTradingPreferences(data);
  } catch (err) {
    console.error("Error fetching trading preferences:", err.message);
  }
}, [userId]);


  const fetchIdCardVariationIdFromlistOfId = async (listOfId) => {
    try {
      const listOfIdString = listOfId.join(","); // Convert the array to a comma-separated string
      const encodedListOfId = encodeURIComponent(listOfIdString); // Properly encode the string

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/IdCardVariationIdFromlistOfId/${encodedListOfId}`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });

      setIdCardVariationIdFromlistOfId(response.data);
      return response.data;
    } catch (error) {
      console.log("Error fetching player options:", error.message);
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (templateTitle === "") {
      newErrors.templateTitle = t("Template Title is required");
    }
    if (typeOfCard === "") {
      newErrors.typeOfCard = t("Type of Card is required");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleTradingPreferenceSelect = async (value) => {
  const parseJson = (s, fallback = []) => {
    try { return JSON.parse(s || '[]'); } catch { return fallback; }
  };
  const splitCsv = (s) =>
    (s ? s.split(',').map(x => x.trim()).filter(Boolean) : []);

  setOpenForm(true);

  if (value === "create") {
    resetAll();
    setIsNewTradingPreference(true);
    return;
  }

  // Load an existing preference
  resetAll();
  const tp = tradingPreferences.find(
    (p) => p.TradingPreferencesId === parseInt(value, 10)
  );
  if (!tp) return;
  
  setIsNewTradingPreference(false);
  setSelectedTradingPreferenceId(tp.TradingPreferencesId);
  setTemplateTitle(tp.TemplateTitle || "");
  setTypeOfCard(tp.TypeOfCard || "Hockey");
  setOtherDetails(tp.OtherDetails || "");

  // common hockey toggles (still present even for Pokemon; harmless)
  setIsOnlyAuto(Boolean(tp.isOnlyAuto));
  setIsOnlyNumber(Boolean(tp.isOnlyNumber));
  setIsOnlyRPA(Boolean(tp.isOnlyRPA));
  setIsOnlyRookie(Boolean(tp.isOnlyRookie));
  setIsOnlyTrueRookie(Boolean(tp.isOnlyTrueRookie));

  // ---------- Sets (IDs + labels) ----------
  const setIds    = parseJson(tp.ListOfSetId);
  const setLabels = splitCsv(tp.SetNames);
  // shape: [SetId, SetLabel]
  const initialSelectedSets = setIds.map((id, i) => [id, setLabels[i] || String(id)]);
  setSelectedSets(initialSelectedSets);

  // Optional: you were keeping this for display
  setSelectedFromSets(tp.FromSets || "");
  setSelectedPokemonCards([]);
  // ---------- Variations (shared: Hockey & Pokémon Items/Trainers) ----------
  const variationIds   = parseJson(tp.ListOfIdVariation);
  const variationNames = splitCsv(tp.VariationNames); // e.g., "Exclusive,/10,Gold"
  const cardNames      = splitCsv(tp.CardNames);      // parallel to variation order
  const pokemonCardsNames = parseJson(tp.CardNamesJSON); // parallel to variation order for Pokémon
  const cardImgs  = JSON.parse(tp.CardImagesJSON || '[]');
  console.log("Loaded pokemonCardsNames", pokemonCardsNames,tp.CardNamesJSON);
  // If you still need IdCardVariation for anything downstream, fetch it:
  // (You can remove this call if you don't need it.)
  let idCardVariationRows = [];
  if (variationIds.length) {
    try {
      idCardVariationRows = await fetchIdCardVariationIdFromlistOfId(variationIds);
    } catch (e) {
      console.warn("fetchIdCardVariationIdFromlistOfId failed", e);
    }
  }
  
  // Hydrate UI state in the same order SQL produced
  variationIds.forEach((variationId, idx) => {
    const variant  = variationNames[idx] || ""; // label for the variation chip
    const cardName = pokemonCardsNames[idx] || "";
    const cardImg  = cardImgs[idx] || "";
    console.log("Hydrating variation:", { variationId, variant, cardName });
    setSelectedCardNames(prev => [...prev, cardName]);
    setSelectedVariations(prev => [...prev, [variant, variationId]]);
    if ((tp.TypeOfCard || "Hockey") === "Pokemon")

      setSelectedPokemonCards(prev => [...prev, [cardName, variationId,cardImg]]);
  });

  // ---------- Branch by type for "players" / "species" & rarities ----------
  if ((tp.TypeOfCard || "Hockey") === "Pokemon") {
    // Pokémon “players” are species / pokemon card ids in ListOfPlayerId
    const pokemonIds    = parseJson(tp.ListOfPlayerId);
    const pokemonLabels = splitCsv(tp.PlayerNames); // from PokemonList.CardName via the Pokémon GET
    const initialSelectedPokemon = pokemonIds.map((id, i) => [
      pokemonLabels[i] || String(id),
      id
    ]);
    setSelectedPokemon(initialSelectedPokemon);
    // // reset Pokémon cards list
    console.log("Loaded selected Pokémon tp:", tp);
    // Rarities
    setSelectedPokemonRarityIds(parseJson(tp.PokemonPreferredRarityIds, []));
    setPokemonRarityExclusive(Boolean(tp.PokemonRarityExclusive));

    // (Optional) Clear hockey-only UI lists to avoid mixing states
    setSelectedPlayers([]);
  } else {
    // Hockey branch: players from ListOfPlayerId + PlayerNames
    const playerIds    = parseJson(tp.ListOfPlayerId);
    const playerLabels = splitCsv(tp.PlayerNames);
    const initialSelectedPlayers = playerIds.map((id, i) => [
      playerLabels[i] || String(id),
      id
    ]);
    setSelectedPlayers(initialSelectedPlayers);

    // (Optional) Clear Pokémon-only UI lists to avoid mixing states
    setSelectedPokemon([]);
    setSelectedPokemonRarityIds([]);
    setPokemonRarityExclusive(false);
  }
};


  useEffect(() => {
    console.log("Trading Preferences:", tradingPreferences);
  }, [tradingPreferences]);

  useEffect(() => {
    console.log("Variation:", selectedVariations);
    console.log("Selected Pokemon Cards:", selectedPokemonCards);
  }, [selectedVariations,selectedPokemonCards]);

  function resetAll() {
    setSelectedPlayers([]);
    setSelectedSets([]);
    setSelectedVariations([]);
    setSelectedCardNames([]);
    setTemplateTitle("");
    setTypeOfCard("");
    setIsOnlyAuto(Boolean(0));
    setIsOnlyNumber(Boolean(0));
    setIsOnlyRPA(Boolean(0));
    setIsOnlyRookie(Boolean(0));
    setIsOnlyTrueRookie(Boolean(0));
    setOtherDetails("");
    setLiveSelectedCardName("");
    setLiveSelectedVariation("");
setPokemonOptions([]);
setSelectedPokemon([]);
setPokemonSpecies(null);
setPokemonSpeciesOptions([]);
setLiveSelectedPokemon([]);
setPokemonAlreadyUsed(false);
setSelectedPokemonCards([]);
    // setSelectedTradingPreferenceId(null);
  }

  const fetchPlayerOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/players`  ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const players = response.data.map((player) => ({
        value: player.PlayerId,
        label: player.Name,
      }));
      setPlayerOptions(players);
    } catch (error) {
      console.log("Error fetching player options:", error.message);
    }
  };

  const fetchSetOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/AddCard/sets`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const sets = response.data.map((set) => ({
        value: set.setId,
        label: set.SetName,
      }));

      setSetOptions(sets);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  const fetchCardOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCard`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const getCards = response.data.map((getCard) => ({
        value: getCard.IdCardVariation,
        label: getCard.cardName,
        name: getCard.fromSet,
      }));

      setVariation(getCards);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  const fetchCardVariationOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCardVariation`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const variations = response.data.map((variation) => ({
        value: variation.IDVariation,
        label: variation.variationName,
        name: variation.IdCardVariation,
      }));

      setCardVariation(variations);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  const fetchListOfSetId = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/AddCard/sets`
        ,{
        withCredentials: true, // ✅ sends cookies/session
      });
      const sets = response.data.map((set) => ({
        value: set.setId,
        label: set.SetName,
      }));

      setSetOptions(sets);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  useEffect(() => {
    fetchTradingPreferencesOptions(activeType);
    // fetchPlayerOptions();
    // fetchSetOptions();
    //fetchCardOptions();
    fetchCardVariationOptions();
  }, [activeType,userId]);

useEffect(() => {
  if (isPokemon) {
    // Pour Pokémon, "variation" = Rarity (pas de dépendance à la carte)
    setFilteredCardVariation(cardVariation);
  } else {
    const filterCardVari = cardVariation.filter(
      (item) => parseInt(item.name) === parseInt(liveSelectedCardName?.[0])
    );
    setFilteredCardVariation(filterCardVari);
  }
}, [cardVariation, liveSelectedCardName, isPokemon]);

  const handleSavePlayer = (selectedValue, selectedLabel) => {
    setLiveSelectedPlayers([selectedLabel, selectedValue]);

    // setSelectedPlayers((prevSelectedPlayers) => [...prevSelectedPlayers, selectedValue]);
  };

  const handleSaveSet = (selectedValue, selectedLabel) => {
    setLiveSelectedSets([selectedValue, selectedLabel]);
  };

  const handleSaveVariation = (label, value) => {
    setSelectedVariation({ label, value });

    console.log("Selected:", label, value);
    setLiveSelectedVariation([label, value]);
  };

  const handleSaveCardName = (label, value) => {
    setSelectedCardName({ label, value });
    console.log("Selected:", label, value);
    setLiveSelectedCardName([value, label]);
    setSelectedVariation(null);
  };

  const handleAddPlayer = () => {
    const playerId = liveSelectedPlayers[0];
    const playerLabel = liveSelectedPlayers[1];

    if (!playerId || !playerLabel) {
      console.log("Player selection is incomplete");
      toast.error(t("Please select a valid player"));
      return;
    }
    // Check if the player ID already exists in selectedPlayers
    const isPlayerAlreadySelected = selectedPlayers.some(
      (player) => player[0] === playerId
    );

    if (isPlayerAlreadySelected) {
      console.log("Player is already selected");
      setPlayerAlreadyUsed(true);
      return;
    }
    setPlayerAlreadyUsed(false);
    const newPlayer = [playerId, playerLabel];
    setSelectedPlayers((prevSelectedPlayers) => [
      ...prevSelectedPlayers,
      newPlayer,
    ]);
  };

  const handleRemovePlayer = (index) => {
    setSelectedPlayers((prevSelectedPlayers) => {
      const updatedPlayers = [...prevSelectedPlayers];
      updatedPlayers.splice(index, 1);
      return updatedPlayers;
    });
  };
  const handleClearSelectionPlayer = () => {
    setLiveSelectedPlayers(null); // Reset selectedPlayer to null to clear the selection
  };

  const handleAddSet = () => {
    const setId = liveSelectedSets[1];
    const setLabel = liveSelectedSets[0];

    if (!setId || !setLabel) {
      console.log("Set selection is incomplete");
      toast.error(t("Please select a valid set"));
      return;
    }
    const isSetAlreadySelected = selectedSets.some((set) => set[0] === setId);
    if (isSetAlreadySelected) {
      console.log("Set is already selected");
      setSetAlreadyUsed(true);
      return;
    }
    setSetAlreadyUsed(false);
    const newSet = [setId, setLabel];
    setSelectedSets((prevSelectedSets) => [...prevSelectedSets, newSet]);
  };

  const handleRemoveSet = (index) => {
    setSelectedSets((prevSelectedSets) => {
      const updatedSets = [...prevSelectedSets];
      updatedSets.splice(index, 1);
      return updatedSets;
    });
  };

  const handleAddVariation = () => {
    const variationLabel =
      liveSelectedCardName[1] + " " + liveSelectedVariation[0];
    const variationId = liveSelectedVariation[1];

    if (!liveSelectedCardName[1] || !liveSelectedVariation[0]) {
      console.log("Variation selection is incomplete");
      toast.error(t("Please select a valid card and variation"));
      return;
    }

    const isVariationAlreadySelected = selectedVariations.some(
      (variation) => variation[1] === variationId
    );
    if (isVariationAlreadySelected) {
      console.log("Variation is already selected");
      setVariationAlreadyUsed(true);
      return;
    }
    setVariationAlreadyUsed(false);

    const newSet = [variationLabel, variationId];
    setSelectedVariations((prevSelectedVariations) => [
      ...prevSelectedVariations,
      newSet,
    ]);
    console.log("newSet", newSet);
    setSelectedCardNames((prevSelectedCardNames) => [
      ...prevSelectedCardNames,
      liveSelectedCardName[1],
    ]);
    console.log(selectedVariations);
    console.log(
      "liveSelectedCardName",
      liveSelectedCardName,
      "liveSelectedCardName[1]",
      liveSelectedCardName[1]
    );
  };

  const handleRemoveVariation = (index) => {
    setSelectedVariations((prevSelectedVariations) => {
      const updatedVariations = [...prevSelectedVariations];
      updatedVariations.splice(index, 1);
      return updatedVariations;
    });
    setSelectedCardNames((prevSelectedCardNames) => {
      const updatedCardNames = [...prevSelectedCardNames];
      updatedCardNames.splice(index, 1);
      return updatedCardNames;
    });
  };

 const handleSave = () => {
  if (!validateFields()) {
    toast.error(t("Please fill in all required fields"));
    return;
  }

  // Build the player/species list depending on the type

 const hockeyPlayerIds  = selectedPlayers.map((item) => item[1]);   // [label, playerId]
  const pokemonIds       = selectedPokemon.map((item) => item[1]);   // [label, pokemonId or cardId]
  const pokemonCardsIds = selectedPokemonCards.map((item) => item[1]);   // [label, pokemonId or cardId]
  const variationIds = selectedVariations.map((item) => item[1]);
  const listOfPlayerLike = (typeOfCard === "Pokemon") ? pokemonIds : hockeyPlayerIds;
  const listOfIdVariationLike = (typeOfCard === "Pokemon") ? pokemonCardsIds : variationIds;
 
  const payload = {
    TemplateTitle: (templateTitle || "").trim(),
    userId,

    // Hockey-style toggles (harmless to store for Pokémon)
    isOnlyAuto: !!isOnlyAuto,
    isOnlyRookie: !!isOnlyRookie,
    isOnlyNumber: !!isOnlyNumber,
    isOnlyRPA: !!isOnlyRPA,
    isOnlyTrueRookie: !!isOnlyTrueRookie,

    TypeOfCard: typeOfCard,                 // "Hockey" | "Pokemon"
    OtherDetails: otherDetails ?? "",

    // Shared lists (store raw IDs)
    ListOfIdVariation: JSON.stringify(listOfIdVariationLike), // [variantLabel, IDVariation] -> IDVariation
    ListOfPlayerId: JSON.stringify(listOfPlayerLike),                              // Hockey: players, Pokémon: species/card IDs
    ListOfSetId: JSON.stringify(selectedSets.map((item) => item[0])),              // [SetId, SetLabel] -> SetId

    // Pokémon-only
    PokemonPreferredRarityIds:
      typeOfCard === "Pokemon" ? JSON.stringify(selectedPokemonRarityIds) : null,
    PokemonRarityExclusive:
      typeOfCard === "Pokemon" ? !!pokemonRarityExclusive : null,

    // Optional flag; include if you use it in UI
    // isDefault: !!isDefault,
  };

  fetch(`${process.env.REACT_APP_API_BASE}/api/add/trading-preferences`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": liveCsrfToken,
    },
    credentials: "include",
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to create trading preference");
      toast.success(t("Trading preference created successfully!"));
      resetAll();
    })
    .catch((err) => {
      console.error("Error adding trading preference:", err);
      toast.error(t("An error occurred while creating the trading preference"));
    });
};


  // const handleUpdate = (itemId) => {
  //   if (!validateFields()) {
  //     toast.error(t("Please fill in all required fields"));
  //     return;
  //   }

  //   const isOnlyAutoParsed = Boolean(isOnlyAuto);
  //   const isOnlyRookieParsed = Boolean(isOnlyRookie);
  //   const isOnlyNumberParsed = Boolean(isOnlyNumber);
  //   const isOnlyRPAParsed = Boolean(isOnlyRPA);
  //   const isOnlyTrueRookieParsed = Boolean(isOnlyTrueRookie);

  //   const integersOnlyVariation = selectedVariations.map((item) => item[1]);
  //   const myIdVariationId = JSON.stringify(integersOnlyVariation);

  //   const integersOnlyPlayers = selectedPlayers.map((item) => item[1]);
  //   const myIdPlayers = JSON.stringify(integersOnlyPlayers);

  //   const integersOnlySets = selectedSets.map((item) => item[0]);
  //   const myIdSets = JSON.stringify(integersOnlySets);

  //   const updatedTradingPreference = {
  //     TemplateTitle: templateTitle,
  //     UserId: userId,
  //     isOnlyAuto: isOnlyAutoParsed,
  //     isOnlyRookie: isOnlyRookieParsed,
  //     isOnlyNumber: isOnlyNumberParsed,
  //     isOnlyRPA: isOnlyRPAParsed,
  //     isOnlyTrueRookie: isOnlyTrueRookieParsed,
  //     TypeOfCard: typeOfCard,
  //     OtherDetails: otherDetails,
  //     ListOfIdVariation: myIdVariationId,
  //     ListOfPlayerId: myIdPlayers,
  //     ListOfSetId: myIdSets,
  //   };

  //   fetch(`${process.env.REACT_APP_API_BASE}/api/update/trading-preferences/${itemId}`, {
  //     method: "PUT",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-csrf-token": liveCsrfToken, // Include CSRF token
  //     },
  //     credentials: 'include', // Include session for authentication
  //     body: JSON.stringify({ updatedData: updatedTradingPreference }),
  //   })
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw new Error("Failed to update trading preference");
  //     }
  //     toast.success(t("Trading preference updated successfully!"));
  //   })
  //   .catch((error) => {
  //     toast.error(t("An error occurred while updating the trading preference"));
  //     console.error("Error updating trading preference:", error);
  //   });
  // };
const handleUpdate = (itemId) => {
  if (!validateFields()) {
    toast.error(t("Please fill in all required fields"));
    return;
  }

  // Build the “player-like” list depending on the card type
  const hockeyPlayerIds  = selectedPlayers.map((item) => item[1]);   // [label, playerId]
  const pokemonIds       = selectedPokemon.map((item) => item[1]);   // [label, pokemonId or cardId]
  const pokemonCardsIds = selectedPokemonCards.map((item) => item[1]);   // [label, pokemonId or cardId]
  const variationIds = selectedVariations.map((item) => item[1]);
  const listOfPlayerLike = (typeOfCard === "Pokemon") ? pokemonIds : hockeyPlayerIds;
  const listOfIdVariationLike = (typeOfCard === "Pokemon") ? pokemonCardsIds : variationIds;
  const updatedTradingPreference = {
    TemplateTitle: (templateTitle || "").trim(),
    userId, // required by your PUT endpoint

    // Hockey-style toggles (harmless for Pokémon)
    isOnlyAuto: !!isOnlyAuto,
    isOnlyRookie: !!isOnlyRookie,
    isOnlyNumber: !!isOnlyNumber,
    isOnlyRPA: !!isOnlyRPA,
    isOnlyTrueRookie: !!isOnlyTrueRookie,

    TypeOfCard: typeOfCard,                        // "Hockey" | "Pokemon"
    OtherDetails: otherDetails ?? "",

    // Shared: store raw IDs for variations & sets
    ListOfIdVariation: JSON.stringify(listOfIdVariationLike), // [variantLabel, IDVariation]
    ListOfPlayerId: JSON.stringify(listOfPlayerLike),                              // Hockey: players, Pokémon: species/card IDs
    ListOfSetId: JSON.stringify(selectedSets.map((item) => item[0])),              // [SetId, SetLabel] -> SetId

    // Pokémon-only extras
    PokemonPreferredRarityIds:
      typeOfCard === "Pokemon" ? JSON.stringify(selectedPokemonRarityIds) : null,
    PokemonRarityExclusive:
      typeOfCard === "Pokemon" ? !!pokemonRarityExclusive : null,
  };

  fetch(`${process.env.REACT_APP_API_BASE}/api/update/trading-preferences/${itemId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": liveCsrfToken,
    },
    credentials: "include",
    body: JSON.stringify(updatedTradingPreference),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Failed to update trading preference");
      toast.success(t("Trading preference updated successfully!"));
    })
    .catch((error) => {
      toast.error(t("An error occurred while updating the trading preference"));
      console.error("Error updating trading preference:", error);
    });
};


  const handleDelete = (tradingPreferenceId) => {
    fetch(
      `${process.env.REACT_APP_API_BASE}/api/delete/trading-preferences/${tradingPreferenceId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-csrf-token": liveCsrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userId }), // <- include userId in body
      }
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 404) {
            toast.error(t("Trading preference not found"));
          } else {
            toast.error(t("Failed to delete trading preference"));
          }
          throw new Error("Network response was not ok");
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        console.log("Trading preference deleted successfully:", data);
        toast.success(t("Trading preference deleted successfully!")); // Update UI or refresh data after deletion
      })
      .catch((error) => {
        console.error("Error deleting trading preference:", error);
        toast.error(
          t("An error occurred while deleting the trading preference")
        );
      });
  };

  // const fetchSuggestions = async (inputValue, typeT) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${typeT}?searchTerm=${inputValue}`
  //       ,{
  //       withCredentials: true, // ✅ sends cookies/session
  //     });
  
  //     const suggestions = mapResponseToOptions(response.data, typeT);
  
  //     // Use switch statement to handle different state setters
  //     switch (typeT) {
  //       case "player":     
  //        setPlayerOptions(suggestions); // Set options for player
  //         break;
  //       case "card":
  //         setVariation(suggestions); // Set options for card
  //         break;
          
  //       case "set":
  //         setFilteredSets(suggestions); // Set options for sets
  //         break;
  //       default:
  //         console.error("Unknown typeT:", typeT);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching suggestions:", error);
  //   }
  // };

const fetchSuggestions = async (inputValue, typeT) => {
  try {
    if (isPokemon) {
      // --- POKÉMON ---

      // 3a) Liste d'espèces (PokémonList)
      if (typeT === "pokemonSpecies") {
        const url = `${process.env.REACT_APP_API_BASE}/api/pokemon/list?q=${encodeURIComponent(inputValue || "")}`;
        const { data } = await axios.get(url, { withCredentials: true });
        const opts = mapResponseToOptions(data || [], "pokemonSpecies");
        setPokemonSpeciesOptions(opts);
        return;
      }

      // 3b) Cartes précises (PokemonCards)
      if (typeT === "pokemonCard") {
        // Optionnel: filtrer par set si l’utilisateur en a choisi un dans la préférence
        const setId = selectedSets?.[0]?.[0] || "";
        const url = `${process.env.REACT_APP_API_BASE}/api/pokemon/cards?${setId ? `setId=${encodeURIComponent(setId)}&` : ""}q=${encodeURIComponent(inputValue || "")}`;
        const { data } = await axios.get(url, { withCredentials: true });
        const opts = mapResponseToOptions(data || [], "pokemonCard");
        setPokemonCardOptions(opts);
        return;
      }

      // Les autres (set) sont déjà gérés ailleurs (adapteSetbyFilteredType)
      if (typeT === "set") return;

      // Rien d’autre côté Pokémon
      return;
    }

    // --- HOCKEY (inchangé) ---
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${typeT}?searchTerm=${encodeURIComponent(inputValue || "")}`,
      { withCredentials: true }
    );
    const suggestions = mapResponseToOptions(response.data, typeT);
    switch (typeT) {
      case "player": setPlayerOptions(suggestions); break;
      case "card":   setVariation(suggestions);     break;
      case "set":    setFilteredSets(suggestions);  break;
      default: break;
    }
  } catch (error) {
    console.error("Error fetching suggestions:", error);
  }
};


const mapResponseToOptions = (data, typeT) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => {
    switch (typeT) {
      // ——— Hockey (unchanged) ———
      case "player":
        return {
          value: item.PlayerId,
          label: item.Name,
          rookieYear: item.RookieYear,
          rookieTeam: item.TeamId,
        };

      case "set":
        // NOTE: you sometimes return setId, sometimes SetId; normalize here if needed
        return { value: item.setId ?? item.SetId, label: item.SetName };

      case "card":
        return { value: item.IdCardVariation, label: item.cardName };

      case "variation":
        return { value: item.IDVariation, label: item.variationName };

      case "DeepSearch":
        return {
          value: item.CardId,
          label: item.SearchTitle,
          Image: item.Image,
        };

      // ——— Pokémon (new) ———
      // /api/pokemon/list → rows like { PokemonId, CardName }
      case "pokemonSpecies":
        return {
          value: item.PokemonId,
          label: item.CardName, // species name
        };

      // /api/pokemon/cards → rows mapped to { CardId, CardName, NumberInSet, RarityName, ... }
      case "pokemonCard":
        console.log('Mapping pokemonCard item:', item);
        return {
          value: item.CardId||item.value,
          label: item.SearchTitle,
          // passthroughs if you want them later
          RarityId: item.RarityId,
          RarityName: item.RarityName,
          ImageFront: item.ImageFront,
          SetId: item.SetId,
          NumberInSet: item.NumberInSet,
        };

      default:
        return { value: "", label: "" };
    }
  });
};

// refs + state

const pendingAutoPickRef = useRef(false);
const [loadingCards, setLoadingCards] = useState(false);
// Load all cards for a given Pokémon set (uses your mapper)
const loadPokemonCardsForSet = async (setId, { autoSelectFirst = true } = {}) => {
  if (!setId) {
    setPokemonCardOptions([]);
    setPokemonCard(null);
    setLiveSelectedPokemonCard(null);
    return;
  }

  try {
    const url = `${process.env.REACT_APP_API_BASE}/api/pokemon/cards?setId=${encodeURIComponent(setId)}&q=`;
    const { data } = await axios.get(url, { withCredentials: true });

    const opts = mapResponseToOptions(data || [], "pokemonCard");
    setPokemonCardOptions(opts);
console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAANOOOOA',opts)
    if (autoSelectFirst && opts.length) {
      const first = opts[0];
      setPokemonCard(first);
      console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',first)
      setLiveSelectedPokemonCard([first.value, first.label,first.ImageFront]);
      
    } else {
      setPokemonCard(null);
      console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAANOOOOA123')
      setLiveSelectedPokemonCard(null);
    }
  } catch (err) {
    console.error("loadPokemonCardsForSet error:", err);
  }
};

// Auto-refresh Pokémon cards whenever the selected set changes
useEffect(() => {
  if (!isPokemon) return;

  // priority: the explicit Pokémon set select; else first of selectedSets [[id,label], ...]
  const activeSetId = pokemonSet?.value || (selectedSets?.length ? selectedSets[0][0] : "");
  loadPokemonCardsForSet(activeSetId, { autoSelectFirst: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps

}, [isPokemon, pokemonSet?.value, selectedSets,pokemonSearchAllSets]);

useEffect(() => {
  if (!isPokemon) return;

  // determine current setId from the dedicated Pokémon set select OR your selectedSets list
  const activeSetId = (pokemonSet?.value) || (selectedSets?.[0]?.[0]) || "";

  // PURGE every other cached set to comply with “cache only current set”
  baseCardsBySetRef.current = activeSetId ? { [activeSetId]: (baseCardsBySetRef.current[activeSetId] || []) } : {};

  if (!activeSetId) {
    setPokemonCardOptions([]);
    return;
  }

  // use cache if present, else fetch baseline for this set
  const cached = baseCardsBySetRef.current[activeSetId];
  if (cached && cached.length) {
    setPokemonCardOptions(cached);
  } else {
    fetchPokemonCardsForSet(activeSetId, ""); // baseline list for the set
  }

  // reset current selection when set changes
  setPokemonCard(null);
  setPokemonCardAlreadyUsed(false);
}, [isPokemon, pokemonSet, selectedSets]);

// 1) Let the adapter accept an explicit type
const adapteSetbyFilteredType = async (inputValue, forcedType) => {
  const TypeOfCard = forcedType || typeOfCard || "Hockey";
  if (!TypeOfCard || (inputValue || "").length < 3) return;

  let url;
  if (TypeOfCard === "Pokemon") {
    url = `${process.env.REACT_APP_API_BASE}/api/pokemon/sets?searchTerm=${encodeURIComponent(inputValue)}`;
  } else {
    url = `${process.env.REACT_APP_API_BASE}/api/searchbar/sets?TypeOfCard=${encodeURIComponent(TypeOfCard)}&searchTerm=${encodeURIComponent(inputValue)}`;
  }

  const { data } = await axios.get(url, { withCredentials: true });
  const options = (data || []).map((set) => ({
    value: set.SetId ?? set.setId,
    label: set.SetName,
  }));
  setFilteredSets(options);
};

// 2) Debounced handler forwards the *current* type
const handleSetInputChange = useCallback(
  debounce((inputValue, currentType) => {
    if ((inputValue || "").length >= 3) {
      adapteSetbyFilteredType(inputValue, currentType);
    } else {
      setFilteredSets([]);
    }
  }, 300),
  [] // fine to keep empty because we pass currentType as an argument
);

// 3) Pass the live type where you call it
// Hockey block:




  

const playersSectionLabel   = isPokemon ? t("Select Card") : t("Select Player");
const playersPlaceholder    = isPokemon ? t("Search cards") : t("Select Players");
const addButtonLabel        = isPokemon ? t("Add Card") : t("Add Player");
const alreadyUsedErrorLabel = isPokemon
  ? t("This card is already in the list")
  : t("This player is already in the list");

// Debounced input router: 'player' for Hockey, 'card' for Pokémon
const handleEntityInputChange = useCallback(
  debounce((inputValue) => {
    if (inputValue.length >= 3) {
      if (isPokemon) {
        // will fill playerOptions with cards (CardId)
        fetchSuggestions(inputValue, "pokemon");
      } else {
        fetchSuggestions(inputValue, "player");
      }
    } else {
      setPlayerOptions([]);
    }
  }, 300),
  [isPokemon]
);



// const handlePokemonCardInput = useCallback(
//   debounce((input) => {
//     if ((input || "").length >= 2) fetchSuggestions(input, "pokemonCard");
//     else setPokemonCardOptions([]);
//   }, 300),
//   []
// );

const handlePokemonCardInput = useCallback(
  debounce(async (input) => {
    const activeSetId = (pokemonSet?.value) || (selectedSets?.[0]?.[0]) || "";
    if (!activeSetId) {
      setPokemonCardOptions([]); // no set, no search
      return;
    }

    const q = (input || "").trim();
    if (q.length >= 2) {
      await fetchPokemonCardsForSet(activeSetId, q); // search in this set
    } else {
      // restore baseline for this set from cache or refetch
      const cached = baseCardsBySetRef.current[activeSetId];
      if (cached && cached.length) {
        setPokemonCardOptions(cached);
      } else {
        await fetchPokemonCardsForSet(activeSetId, "");
      }
    }
  }, 300),
  [pokemonSet, selectedSets]
);

// const handlePokemonCardInput = useCallback(
//   debounce((input) => {
//     const setId = pokemonSet?.value || selectedSets?.[0]?.[0] || null;

//     // If user typed >=2 chars, do a filtered search in the chosen scope
//     if ((input || "").length >= 2) {
//       fetchPokemonCards({
//         setId,
//         q: input,
//         allSets: pokemonSearchAllSets || !setId, // if no set is chosen, fall back to all sets
//       });
//       return;
//     }

//     // Otherwise restore the base list (depends on scope)
//     if (pokemonSearchAllSets) {
//       setPokemonCardOptions(baseAllCardsRef.current || []);
//     } else if (setId) {
//       setPokemonCardOptions(baseCardsBySetRef.current[setId] || []);
//     } else {
//       setPokemonCardOptions([]);
//     }
//   }, 300),
//   [pokemonSet, selectedSets, pokemonSearchAllSets]
// );

  const handlePlayerInputChange = useCallback(
    debounce((inputValue) => {
      if (inputValue.length >= 3) {
        fetchSuggestions(inputValue, "player");
      } else {
        setPlayerOptions([]); // Clear options if input is too short
      }
    }, 300),
    [] // Dependencies are empty to keep debounce stable
  );

  // ✅ Debounce the card input change function
  const handleCardInputChange = useCallback(
    debounce((inputValue) => {
      if (inputValue.length >= 3) {
        fetchSuggestions(inputValue, "card");
      } else {
        setVariation([]); // Clear variations if input is too short
      }
    }, 300), []
  );


// const SelectedGrid = ({ selectedData, handleRemoveData }) => (
//   <div className="selected-items-container">
//     {selectedData.map((item, idx) => (
//       <div key={`${item[0]}-${idx}`} className="selected-item">
//         <p>{item[0]}</p>
//         <button
//           type="button"
//           aria-label="Remove"
//           onClick={() => handleRemoveData(idx)}
//         >
//           ×
//         </button>
//       </div>
//     ))}
//   </div>
// );
// SelectedGrid.jsx
// SelectedGrid.jsx
const SelectedGrid = ({
  selectedData,
  handleRemoveData,
  // set mode (radio-like) for Sets
  isSetMode = false,
  activeValue,
  onSelectSet,
  // indexes into each tuple
  labelIndex = 1,
  valueIndex = 0,
  // NEW: show image cards (for Pokémon only)
  showPokemonImages = false,
  imageIndex = 2,
}) => {
  const isPokemonMode = !!showPokemonImages;

  if (isPokemonMode) {
    // Image-card layout for Pokémon cards: [label, id, img]
   return (
  <div className="pk-grid pk-grid--cards">   {/* <- grid wrapper */}
    {selectedData.map((item, idx) => {
      const label = item?.[labelIndex];
      const value = item?.[valueIndex];
      const img   = item?.[imageIndex];

      return (
        <button
          key={`${value}-${idx}`}
          type="button"
          className="pk-card"
          onClick={() => onSelectSet && onSelectSet(value, label, img)}
          title={label}
        >
          <div className="pk-card-thumb">
            {img ? <img src={img} alt={label} loading="lazy" /> : <div className="pk-noimg">No image</div>}
          </div>
          <div className="pk-card-title">{label}</div>
          {handleRemoveData && (
            <span
              className="pk-remove"
              onClick={(e)=>{ e.stopPropagation(); handleRemoveData(idx); }}
              aria-label="Remove"
            >
              ×
            </span>
          )}
        </button>
      );
    })}
  </div>
);
  }

  // Default segmented chips (hockey, sets, etc.)
  return (
    <div
      className={`selected-items-container ${isSetMode ? "segmented" : ""}`}
      style={{ gap: 8, display: "flex", flexWrap: "wrap" }}
    >
      {selectedData.map((item, idx) => {
        const label = item?.[labelIndex];
        const value = item?.[valueIndex];
        const isActive = isSetMode && String(activeValue) === String(value);

        return (
          <button
            key={`${value}-${idx}`}
            type="button"
            className={`seg ${isActive ? "is-active" : ""}`}
            role={isSetMode ? "radio" : undefined}
            aria-checked={isSetMode ? isActive : undefined}
            onClick={() => isSetMode && onSelectSet && onSelectSet(value, label)}
            title={isSetMode ? (isActive ? "Selected set for search" : "Click to use this set") : label}
            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            {isSetMode && <span className="seg-check" aria-hidden>✓</span>}
            <span className="chip-label">{label}</span>
            {handleRemoveData && (
              <span
                className="chip-remove"
                role="button"
                aria-label="Remove"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveData(idx);
                }}
                style={{ marginLeft: 6, opacity: 0.9 }}
              >
                ×
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};


const OptionWithThumb = (props) => {
  const { data, selectProps } = props;

  // current, filtered list shown by react-select
  const opts = Array.isArray(selectProps.options) ? selectProps.options : [];
  const idx  = opts.findIndex(o => o.value === data.value);

  // only show images for the first 5 options
  const showThumb = idx > -1 && idx < 5 && !!data.ImageFront;

  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {showThumb && (
          <img
            src={data.ImageFront}
            alt=""
            width={32}
            height={32}
            style={{ borderRadius: 6, objectFit: "cover" }}
            loading="lazy"
          />
        )}
        <span>{data.label}</span>
      </div>
    </components.Option>
  );
};

  
if (userId === null) {
    localStorage.setItem('intendedPath', window.location.pathname + window.location.search);
      navigate('/login');
    return;
  }

return (
  <section className="tprefs">
    {!openForm ? (
      <>
        <div className="tprefs__header">
          <h2>{t("Trading")}</h2>
          <button
            className="btn btn-primary"
            style={{ marginLeft: "auto",maxWidth:'20rem' }}
            onClick={() => handleTradingPreferenceSelect("create")}
          >
            {t("Create a new preference")}
          </button>
        </div>
 <GlobalRadioButton
        // current value
        activeType={activeType}
         
        // update handler
        setActiveType={setActiveType}

        // labels (can be strings or JSX)
        leftLabel={"Hockey"}
        rightLabel={"Pokemon"}
        thisName="sport-switcher"
    
         
        // optional extras your slider might support
        size="sm"           // if your component has a size prop
        ariaLabel="Sport"   // a11y
        t={t}
      />
        <div className="tprefs__list">
          {tradingPreferences.map((p) => (
            <article className="tprefs-row" key={p.TradingPreferencesId}>
              <div className="tprefs-row__title">{p.TemplateTitle}</div>
              <div className="tprefs-row__actions">
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    handleTradingPreferenceSelect(p.TradingPreferencesId)
                  }
                >
                  {t("Edit")}
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleDelete(p.TradingPreferencesId)}
                >
                  {t("Delete")}
                </button>
              </div>
            </article>
          ))}

          {tradingPreferences.length === 0 && (
            <div className="empty">
              <p>{t("No trading preferences yet.")}</p>
              <button
                className="btn btn-primary"
                onClick={() => handleTradingPreferenceSelect("create")}
              >
                {t("Create your first one")}
              </button>
            </div>
          )}
        </div>
      </>
    ) : (
      <div className="tprefs-form">
        <h3 style={{ marginLeft: "auto",marginRight: "auto" }}>{t("Create Trading Preference")}</h3>
        <div className="tprefs-form__head">
   
        <button
    type="button"
    className="btn btn--ghost btn--icon"
    title={t("Back")}
    aria-label={t("Back")}
    onClick={()=>setOpenForm(false)}
  >
    <span className="ico">←</span>
    {/* <span className="btn__label">{t("Back")}</span> */}
  </button>
         
          <button className="btn btn-ghost" onClick={resetAll}>
            {t("Clear the form")}
          </button>
        </div>
 
        <div className="card">
          <div className="form-grid">
            {/* Template Title */}
            <div className="field col-6">
              <label htmlFor="templateTitle">{t("Template Title")} *</label>
              <input
                id="templateTitle"
                className="input"
                type="text"
                value={templateTitle}
                maxLength={140}
                onChange={(e) => setTemplateTitle(e.target.value)}
              />
              {errors.templateTitle && (
                <div className="field__error">{errors.templateTitle}</div>
              )}
            </div>

            {/* Type of Card */}
            <div className="field col-6">
              <label htmlFor="typeOfCard">{t("Type of Card")} *</label>
              <Select
                inputId="typeOfCard"
                classNamePrefix="rs" // for styling
                  className="form-control"
                  styles={formSelectStyles}
                value={
                  typeOfCard ? { label: typeOfCard, value: typeOfCard } : null
                }
                onChange={(opt) => setTypeOfCard(opt.value)}
                options={[
                  { label: "Hockey", value: "Hockey" },
                  { label: "Basketball", value: "Basketball" },
                  { label: "Pokemon", value: "Pokemon" },
                ]}
                defaultValue={{ label: "Hockey", value: "Hockey" }}
                
              />
              {errors.typeOfCard && (
                <div className="field__error">{errors.typeOfCard}</div>
              )}
            </div>

            {/* Players */}
   {/* Players (Hockey only) */}
{typeOfCard === "Hockey" && (
  <>
  <div className="field col-12">
    <label>{t("Select Player")}(s)</label>
    <div className="inline">
      <Select
        classNamePrefix="rs"
        className="form-control"
        styles={formSelectStyles}
        options={playerOptions}
        placeholder={t("Select Players")}
        onChange={(opt) => handleSavePlayer(opt.value, opt.label)}
        onInputChange={(input) => handlePlayerInputChange(input)}
      />
      <button className="btn btn-primary" onClick={handleAddPlayer} style={{ maxWidth: "15rem" }}>
        {/* {t("Add Player")} */}
        <MySvgButtonPlus width={16} height={16} />
      </button>
    </div>
    {playerAlreadyUsed && (
      <div className="field__error">
        {t("This player is already in the list")}
      </div>
    )}
    <SelectedGrid
      selectedData={selectedPlayers}
      handleRemoveData={handleRemovePlayer}
    />
  </div>

       
            <div className="field col-12">
              <label>{t("Select Set")}(s)</label>
              <div className="inline">
                <Select
                  classNamePrefix="rs"
                    className="form-control"
                  styles={formSelectStyles}
                  options={filteredSets}
                  placeholder={t("Select Set")}
                  onChange={(opt) => handleSaveSet(opt.value, opt.label)}
                  onInputChange={(input) => handleSetInputChange(input,"Hockey")}
                />
                <button className="btn btn-primary" onClick={handleAddSet}>
                  {/* {t("Add Set")} */}
                  <MySvgButtonPlus width={16} height={16} />
                </button>
              </div>
              {setAlreadyUsed && (
                <div className="field__error">
                  {t("This set is already in the list")}
                </div>
              )}
              <SelectedGrid
                selectedData={selectedSets}
                handleRemoveData={handleRemoveSet}
              />
            </div>

            {/* Variations */}

            <div className="field col-12">
              <label>{t("Specify a variation or insert")}</label>
              <div className="inline wrap">
                <Select
                  classNamePrefix="rs"
                  
                  options={variation}
                  value={selectedCardName}
                className="form-control"
                  styles={formSelectStyles}
                  placeholder={t("Specify a card")}
                  onInputChange={(input) => handleCardInputChange(input)}
                  onChange={(opt) => handleSaveCardName(opt.label, opt.value)}
                />
                <Select
                  classNamePrefix="rs"
                  
                  options={filteredCardVariation}
                  value={selectedVariation}
                   className="form-control"
                  styles={formSelectStyles}
                  placeholder={t("Select the variation")}
                  onChange={(opt) => handleSaveVariation(opt.label, opt.value)}
                />
                <button className="btn btn-primary" onClick={handleAddVariation}>
                  <MySvgButtonPlus width={16} height={16} />
                  {/* {t("Add variation")} */}
                </button>
              </div>
              {variationAlreadyUsed && (
                <div className="field__error">
                  {t("This variation is already in the list")}
                </div>
              )}
              <SelectedGrid
                selectedData={selectedVariations}
                handleRemoveData={handleRemoveVariation}
              />
            </div>

            {/* Attributes */}
            <div className="field col-12">
              <label>{t("Attribut(s)")}</label>
              <div className="segmented">
                <button
                  type="button"
                  className={`seg ${isOnlyAuto ? "is-active" : ""}`}
                  aria-pressed={isOnlyAuto}
                  onClick={() => setIsOnlyAuto(!isOnlyAuto)}
                >
                  {t("Only Auto")}
                </button>
                <button
                  type="button"
                  className={`seg ${isOnlyRookie ? "is-active" : ""}`}
                  aria-pressed={isOnlyRookie}
                  onClick={() => setIsOnlyRookie(!isOnlyRookie)}
                >
                  {t("Only Rookie")}
                </button>
                <button
                  type="button"
                  className={`seg ${isOnlyNumber ? "is-active" : ""}`}
                  aria-pressed={isOnlyNumber}
                  onClick={() => setIsOnlyNumber(!isOnlyNumber)}
                >
                  {t("Only Numbered")}
                </button>
                <button
                  type="button"
                  className={`seg ${isOnlyRPA ? "is-active" : ""}`}
                  aria-pressed={isOnlyRPA}
                  onClick={() => setIsOnlyRPA(!isOnlyRPA)}
                >
                  {t("Only RPA")}
                </button>
                <button
                  type="button"
                  className={`seg ${isOnlyTrueRookie ? "is-active" : ""}`}
                  aria-pressed={isOnlyTrueRookie}
                  onClick={() => setIsOnlyTrueRookie(!isOnlyTrueRookie)}
                >
                  {t("Only True Rookie")}
                </button>
              </div>
            </div>
            </>
)}

{/* Pokémon species (Pokémon only) */}

{/* === POKÉMON ONLY === */}
{/* === POKÉMON ONLY — use same grid as Hockey === */}
{isPokemon && (
  <>
    {/* Select Set(s) */}
    <div className="field col-12">
      <label>{t("PokemonSet")}</label>
      <div className="inline">
        <Select
          classNamePrefix="rs"
          className="form-control"
          styles={formSelectStyles}
          placeholder={t("SearchPokemonSet")}
          value={pokemonSet}
          onChange={(opt) => {
            setPokemonSet(opt);
            if (opt) handleSaveSet(opt.value, opt.label);
          }}
          onInputChange={(input) => handleSetInputChange(input,"Pokemon")}
          options={filteredSets}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            handleAddSet();
            toast.success(t("Set is selected"));
          }}
          disabled={!pokemonSet?.value}
          
        >
          {/* {t("Add Set")} */}
        <MySvgButtonPlus width={16} height={16} />
        </button>
      </div>
      {setAlreadyUsed && (
        <div className="field__error">{t("This set is already in the list")}</div>
      )}
   <SelectedGrid
  selectedData={selectedSets}      // [[SetId, SetLabel], ...]
  labelIndex={0}
  valueIndex={1}
  isSetMode
  activeValue={pokemonSet?.value ?? selectedSets?.[0]?.[0]}
  onSelectSet={(setId, label) => {
    setPokemonSet({ value: setId, label:label });
    setPokemonSearchAllSets(false); // optional: force “within selected set”
    loadPokemonCardsForSet(setId, { autoSelectFirst: true });
  }}
  handleRemoveData={handleRemoveSet}
/>
    </div>

    {/* Pokémon Card(s) */}
    <div className="field col-12">
      <label>{t("PokemonCard")}</label>
      <div >
<div
  role="radiogroup"
  aria-label={t("Search scope")}
  className="inline"
  style={{ gap: 12, alignItems: "center", flexWrap: "wrap" }}
>
  {/* <span className="muted">{t("Search scope")}:</span> */}

  <div className="segmented" style={{ display: "inline-flex" }}>
    {/* Within selected set */}
    <button
      type="button"
      role="radio"
      aria-checked={!pokemonSearchAllSets}
      className={`seg ${!pokemonSearchAllSets ? "is-active" : ""}`}
      onClick={() => setPokemonSearchAllSets(false)}
      title={t("SearchWithinSelectedSet")}
      disabled={!pokemonSet?.value && selectedSets.length === 0}
    >
      <span className="seg-check" aria-hidden>✓</span>
      {t("SearchWithinSelectedSet")}
    </button>

    {/* Across all sets */}
    <button
      type="button"
      role="radio"
      aria-checked={pokemonSearchAllSets}
      className={`seg ${pokemonSearchAllSets ? "is-active" : ""}`}
      onClick={() => setPokemonSearchAllSets(true)}
      title={t("SearchAcrossAllSets")}
    >
      <span className="seg-check" aria-hidden>✓</span>
      {t("SearchAcrossAllSets")}
    </button>
  </div>

  <div className="scope-help">
    {!pokemonSearchAllSets ? t("ScopeHelpWithin") : t("ScopeHelpAll")}
  </div>
</div>

<div className="inline" style={{ gap: 12, alignItems: "center",marginTop:'12px' }}>
  <Select
    classNamePrefix="rs"
    /* remove className="form-control" here */
    styles={selectRowStyles}
    placeholder={t("SearchPokemonCard")}
    value={pokemonCard}
    components={{ Option: OptionWithThumb }}
    onChange={(opt) => {
      setPokemonCard(opt);
      console.log('Selected Pokémon card option:', opt);
      setLiveSelectedPokemonCard(opt ? [opt.value, opt.label] : null);
    }}
    onInputChange={(input) => {
      if ((input || "").length >= 2) {
        if (pokemonSearchAllSets) fetchPokemonCards({ allSets: true, q: input });
        else {
          const setId = pokemonSet?.value || (selectedSets[0]?.[0] ?? "");
          if (!setId) return;
          fetchPokemonCards({ setId, q: input, allSets: false });
        }
      } else {
        if (pokemonSearchAllSets) setPokemonCardOptions(baseAllCardsRef.current || []);
        else {
          const setId = pokemonSet?.value || (selectedSets[0]?.[0] ?? "");
          setPokemonCardOptions(baseCardsBySetRef.current[setId] || []);
        }
      }
    }}
    onBlur={() => {
      if (pokemonSearchAllSets) {
        if (baseAllCardsRef.current.length) setPokemonCardOptions(baseAllCardsRef.current);
        else fetchPokemonCards({ allSets: true, q: "" });
      } else {
        const setId = pokemonSet?.value || (selectedSets[0]?.[0] ?? "");
        if (!setId) return setPokemonCardOptions([]);
        const cached = baseCardsBySetRef.current[setId];
        if (cached) setPokemonCardOptions(cached);
        else fetchPokemonCards({ setId, q: "", allSets: false });
      }
    }}
    onMenuClose={() => {
      const setId = pokemonSet?.value || selectedSets?.[0]?.[0] || lastSetIdRef.current;
      if (pokemonSearchAllSets) setPokemonCardOptions(baseAllCardsRef.current || []);
      else if (setId) setPokemonCardOptions(baseCardsBySetRef.current[setId] || []);
      else setPokemonCardOptions([]);
    }}
    options={pokemonCardOptions}
    isDisabled={!pokemonSearchAllSets && !pokemonSet?.value && selectedSets.length === 0}
    noOptionsMessage={() =>
      (!pokemonSearchAllSets && !pokemonSet?.value && selectedSets.length === 0)
        ? t("PickSetFirst")
        : t("No results")
    }
  />

  <AddMiniBtn
    onClick={() => {
      const id = pokemonCard?.value;
      const label = pokemonCard?.label;
      console.log('Current selected Pokémon card:', pokemonCard);
      console.log('Adding Pokémon card:', { id, label },'liveSelectedPokemonCard',liveSelectedPokemonCard);
      if (!id || !label) {

        toast.error(t("Please select a valid card"));
        return;
      }
      const exists = selectedPokemonCards.some((p) => p[1] === id);
      if (exists) { setPokemonCardAlreadyUsed(true); return; }
      setPokemonCardAlreadyUsed(false);
      setSelectedPokemonCards((prev) => [...prev, [label, id]]);

      toast.success(t("Card is selected"));
    }}
    disabled={!pokemonCard}
    label="Add card"
  />
</div>

      </div>

      {pokemonCardAlreadyUsed && (
        <div className="field__error">{t("This card is already in the list")}</div>
      )}

 <SelectedGrid
  selectedData={selectedPokemonCards}   // [label, id, img]
  labelIndex={0}
  valueIndex={1}
  imageIndex={2}
  showPokemonImages
  handleRemoveData={(idx) =>
    setSelectedPokemonCards(prev => prev.filter((_, i) => i !== idx))
  }
/>
    </div>

{/* === Pokémon (species) ONLY === */}
<div className="field col-12">
  <label>{t("PokemonOnly")}</label>
  <div className="inline" style={{ gap: 12, alignItems: "center" }}>
    <Select
      classNamePrefix="rs"
      className="form-control"
      styles={formSelectStyles}
      placeholder={t("SearchPokemonOnly")}
      value={pokemonSpecies}
      onChange={handleSavePokemon}
      onInputChange={(input) => handlePokemonSpeciesInput(input)}
      options={pokemonSpeciesOptions}
      noOptionsMessage={() => t("No results")}
    />

    <AddMiniBtn
      onClick={handleAddPokemon}
      disabled={!pokemonSpecies}
      label={t("AddPokemon")}
    />
  </div>

  {pokemonAlreadyUsed && (
    <div className="field__error">{t("This Pokémon is already in the list")}</div>
  )}

  <SelectedGrid
    labelIndex={0}
  valueIndex={1}
    selectedData={selectedPokemon}
    handleRemoveData={(idx) =>
      setSelectedPokemon(prev => {
        const next = [...prev];
        next.splice(idx, 1);
        return next;
      })
    }
  />
</div>




    {/* Exclusively + Rarities */}
    <div className="field col-12">
      <div className="inline" style={{ gap: 12, flexWrap: "wrap" }}>
        <label style={{ marginBottom: 0 }}>{t("Exclusively")}:</label>
        <button
          type="button"
          className={`seg ${pokemonRarityExclusive ? "is-active" : ""}`}
          aria-pressed={pokemonRarityExclusive}
          onClick={() => setPokemonRarityExclusive((prev) => !prev)}
        >
          {pokemonRarityExclusive ? t("On") : t("Off")}
        </button>
      </div>

      <div style={{ marginTop: 12 }}>
        <label>{t("Rarities")}</label>
        <div className="segmented" style={{ flexWrap: "wrap", gap: 8 }}>
          {pokemonRarityOptions.map((r) => {
            const active = selectedPokemonRarityIds.includes(r.value);
            return (
              <button
                key={r.value}
                type="button"
                className={`seg ${active ? "is-active" : ""}`}
                aria-pressed={active}
                onClick={() =>
                  setSelectedPokemonRarityIds((prev) =>
                    active ? prev.filter((id) => id !== r.value) : [...prev, r.value]
                  )
                }
                title={r.label}
              >
                {r.label}
              </button>
            );
          })}
        </div>

        {selectedPokemonRarityIds.length > 0 && (
          <div className="inline" style={{ marginTop: 8, gap: 8 }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setSelectedPokemonRarityIds([])}
            >
              {t("Clear rarities")}
            </button>
          </div>
        )}
      </div>
    </div>
  </>
)}



     

            {/* Other details */}
            <div className="field col-12">
              <label htmlFor="otherDetails">{t("Other Details")}</label>
              <textarea
                id="otherDetails"
                className="textarea"
                value={otherDetails}
                onChange={(e) => setOtherDetails(e.target.value)}
                rows={5}
                maxLength={398}
              />
            </div>

            {/* Actions */}
            <div className="actions col-12">
              {isNewTradingPreference ? (
                <button className="btn btn-primary" onClick={handleSave}>
                  {t("Create")}
                </button>
              ) : (
                <button
                  className="btn btn-primary"
                  onClick={() => handleUpdate(selectedTradingPreferenceId)}
                >
                  {t("Update")}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )}
  </section>
);

};

export default TradingPreference;
